import { render, staticRenderFns } from "./DockBar.vue?vue&type=template&id=145e44a0"
import script from "./DockBar.vue?vue&type=script&lang=js"
export * from "./DockBar.vue?vue&type=script&lang=js"
import style0 from "./DockBar.vue?vue&type=style&index=0&id=145e44a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports